import {create} from "zustand";

// CDN base URL for auth modal images
const AUTH_MODAL_IMAGES_CDN = "https://images.cdn.jogacompix.com/images";

/**
 * Filter banners by target page. A banner is considered visible on a given
 * page when its `pages` field is empty (legacy = visible everywhere) or when
 * the comma-separated list contains the page key.
 *
 * @param {Array} banners - Banners array (already filtered by section).
 * @param {string} page - Page key, e.g. "home", "slots", "casino-live", "mini-juegos".
 */
export const filterBannersByPage = (banners, page) => {
  if (!Array.isArray(banners)) return [];
  return banners.filter(banner => {
    const pages =
      typeof banner.pages === "string"
        ? banner.pages
            .split(",")
            .map(p => p.trim())
            .filter(Boolean)
        : [];
    return pages.length === 0 || pages.includes(page);
  });
};

export const useAppConfig = create(set => ({
  bankName: "Banco Plaza",
  RIF: null,
  PagoMovilNumber: null,
  bannersCarousel: [],
  homeBodyBanners: [],
  webBanners: [],
  storyAds: [],
  tabsConfig: [],
  featureFlags: {
    quinielaEnabled: false,
    homeLayoutEnabled: false,
  },
  // Auth modal images configuration
  authModalImages: {
    loginDesktopImage: null,
    loginMobileImage: null,
    registrationDesktopImage: null,
    registrationMobileImage: null,
  },
  setFeatureFlags: featureFlags => {
    set({
      featureFlags: {
        quinielaEnabled: featureFlags?.quiniela_enabled ?? false,
        homeLayoutEnabled: featureFlags?.home_layout_enabled ?? false,
      },
    });
  },
  setTabsConfig: tabsConfig => {
    set({
      tabsConfig,
    });
  },

  setPMInfo: (bankName, RIF, PagoMovilNumber) => {
    set({
      bankName,
      RIF,
      PagoMovilNumber,
    });
  },
  setBannersCarousel: banners => {
    // Filter the banners based on active and section
    const activePromoBanners = banners.filter(banner => banner.active && banner.section === "PromoBanners");
    const activeBodyBanners = banners.filter(banner => banner.active && banner.section === "BodyBanner");
    const activeWebBanners = banners
      .filter(banner => banner.active && banner.section === "WebPromoBanners")
      .sort((a, b) => (a.priority ?? 0) - (b.priority ?? 0));
    const activeStoryAds = banners.filter(banner => banner.active && banner.section === "StoryAds");
    set({
      bannersCarousel: activePromoBanners,
      homeBodyBanners: activeBodyBanners,
      webBanners: activeWebBanners,
      storyAds: activeStoryAds,
    });
  },
  setAuthModalImages: authModalImagesData => {
    // Build full URLs from the image keys
    const buildImageUrl = key => (key ? `${AUTH_MODAL_IMAGES_CDN}/${key}` : null);

    set({
      authModalImages: {
        loginDesktopImage: buildImageUrl(authModalImagesData?.login_desktop_image_key),
        loginMobileImage: buildImageUrl(authModalImagesData?.login_mobile_image_key),
        registrationDesktopImage: buildImageUrl(authModalImagesData?.registration_desktop_image_key),
        registrationMobileImage: buildImageUrl(authModalImagesData?.registration_mobile_image_key),
      },
    });
  },
}));
